import React, { useState } from "react";
import ColorPicker from "../components/ColorPicker";
import DoBQuestion from "../components/Form/DoBQuestion";
import NameQuestion from "../components/Form/NameQuestion";
import ProfileImage from "../components/ProfileImage";
import newProfileReq, { AddProfileReq } from "../Requests";

import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import GenderQuestion from "../components/Form/GenderQuestion";
//import ScorePercentDisplay from "../components/ScorePercentDisplay.js";
function Home(props) {
  //#region constants
  let EditMode = props.editMode;
  if (EditMode === undefined) EditMode = false;
  let obj = {};
  init();
  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);

  const [openConfirm, setOpenConfirm] = useState(false);
  const closeConfirmModal = () => setOpenConfirm(false);
  const [inputs, setInputs] = useState(obj);
  const [check, setCheck] = useState(["", ""]);
  let QDB = props.QDB;
  //console.log(QDB, typeof QDB);
  if (typeof QDB === "string") QDB = JSON.parse(props.QDB);
  //console.log(QDB, typeof QDB);

  const bgColorArr = [
    "#f44336",
    "#e91e63",
    "#9c27b0",
    "#673ab7",
    "#3f51b5",
    "#2196f3",
    "#7FBCE1",
    "#00bcd4",
    "#009688",
    "#4caf50",
    "#8bc34a",
    "#cddc39",
    "#ffeb3b",
    "#ffc107",
    "#ff9800",
    "#ff5722",
    "#795548",
    "#607d8b",
  ];
  const fgColorArr = [
    "#202020",
    "#A0A0A0",
    "#FFFFFF",
    "#EBD3C5",
    "#FFE39F",
    "#65371E",
  ];
  //#endregion
  //#region Handler functions
  const handleValue = (event) => {
    const name = event.target.id;
    const value = event.target.value;
    const iType = event.target.type;

    //console.log(`N:${name} V: ${value} Type: ${iType}`);
    setInputs((values) => ({
      ...values,
      [name]: { val: value, valType: iType },
    }));
  };
  function init() {
    if (EditMode === true) {
      let splitName = props.defaultName.split(" ");

      obj = {
        Name_First: { val: splitName[0], valType: "text" },
        Name_Last: {
          val: splitName.length > 2 ? splitName[1] : "",
          valType: "text",
        },
        Name_Suffix: {
          val: splitName.length > 3 ? splitName[2] : "",
          valType: "text",
        },
        DOB_Month: { val: props.defaultDOB.mm, valType: "text" },
        DOB_Day: { val: props.defaultDOB.dd, valType: "text" },
        DOB_Year: { val: props.defaultDOB.yyyy, valType: "text" },
        Gender: { val: props.defaultGender, valType: "select-one" },
        imgFG: { val: props.defaultFG, valType: "text" },
        imgBG: { val: props.defaultBG, valType: "text" },
      };
    }
  }
  function handleFG(event) {
    setInputs((values) => ({
      ...values,
      ["imgFG"]: { val: event.hex, valType: "color" },
    }));
    //console.log(`N: imgFG V= ${event.hex}`);
  }
  function handleBG(event) {
    setInputs((values) => ({
      ...values,
      ["imgBG"]: { val: event.hex, valType: "color" },
    }));
    //console.log(`N: imgBG V= ${event.hex}`);
  }
  function checkColors() {
    if (EditMode === true) {
      if (!inputs.imgFG) {
        inputs["imgFG"] = { val: props.defaultFG, valType: "color" };
      }

      if (!inputs.imgBG) {
        inputs["imgBG"] = { val: props.defaultBG, valType: "color" };
      }
      return;
    }
    if (!inputs.imgFG) {
      inputs["imgFG"] = { val: "#ffffff", valType: "color" };
    }

    if (!inputs.imgBG) {
      inputs["imgBG"] = { val: "#7FBCE1", valType: "color" };
    }
  }

  function getCol(BorF) {
    checkColors();
    if (BorF === "B") {
      return inputs.imgBG.val;
    }
    return inputs.imgFG.val;
  }
  function handleSubmit(event) {
    event.preventDefault();
    //console.log(`UserNameKey = ${props.profileData.QFUserID}`);
    checkColors();
    setCheck(isValidForm());
    if (isValidForm() === true) {
      /*console.log(
        `sending ${props.profileData.QFUserID} and ${props.user.attributes.email}`
      );*/
      //console.log("form is Valid");
      if (EditMode === false) {
        //console.log("Not Editing");
        if (props.new) {
          //console.log("Add new account");
          newProfileReq(inputs, props.userNameKey, props.user.attributes.email);
        } else {
          //console.log("Add Profile to existing account");
          AddProfileReq(
            inputs,
            props.userNameKey,
            getName(),
            props.profileData,
            false,
            props.afterSubmit
          );
        }
      } else {
        setOpenConfirm(true);
      }
    } else {
      setOpen((o) => !o);
      //console.log("Nope!", check[0]);
    }
  }
  //#endregion
  function ModifyProfile() {
    //console.log("modifying profile");
    //console.log("props.arrayIndex :>> ", props.arrayIndex);
    AddProfileReq(
      inputs,
      props.userNameKey,
      getName(),
      props.profileData,
      props.arrayIndex,
      props.afterSubmit
    );
    //console.log("modifying existing profile");
    //console.log(inputs);
  }
  function isValidForm() {
    let now = new Date();
    let ProfileNames = [];
    //console.log(now.getFullYear());
    if (props.profileData !== undefined)
      for (let i = 0; i < props.profileData.Profiles.length; i++) {
        const name = props.profileData.Profiles[i].Name;
        ProfileNames.push(name);
        if (name.trim().toUpperCase() === getName().trim().toUpperCase())
          if (
            getName().trim().toUpperCase() !==
            props.defaultName.trim().toUpperCase()
          ) {
            return [
              "There is already a Profile with this Name",
              "Please use a different name or use a suffix such as 'Jr' to diferentiate",
            ];
          }
      }
    //console.log(ProfileNames);
    if (
      inputs.Name_First === undefined ||
      inputs.Name_Last === undefined ||
      inputs.DOB_Month === undefined ||
      inputs.DOB_Day === undefined ||
      inputs.DOB_Year === undefined
    ) {
      return [
        "First Name, Last Name, and Date of Birth are all required fields.",
        "Please fill them out before pressing submit.",
      ];
    }
    if (inputs.DOB_Day.val < 1 || inputs.DOB_Day.val > 31)
      return [
        "Day is not a valid day of the month",
        "Please make sure the day is between 1 and 31",
      ];
    if (inputs.DOB_Month.val < 1 || inputs.DOB_Month.val > 12)
      return [
        "Month in Date of Birth field is not valid",
        "Please make sure the month is not between 1 and 12",
      ];
    if (inputs.DOB_Year.val < 1900 || inputs.DOB_Year.val > now.getFullYear())
      return [
        "Date of Birth Year is too far into the future or past",
        "Please make sure the year is between 1900 and today",
      ];
    return true;
  }
  function getName() {
    var output = "";
    if (inputs.Name_First) {
      output += inputs.Name_First.val.trim();
    }
    if (inputs.Name_Last) {
      output += " " + inputs.Name_Last.val.trim();
    }
    if (inputs.Name_Suffix) {
      output += " " + inputs.Name_Suffix.val.trim();
    }
    return output;
  }

  let classList = EditMode === true ? "" : "hoverbox";

  return (
    <div>
      <div
        className={classList}
        style={{ width: "95%", display: "inline-block" }}
      >
        {EditMode === true ? (
          <h1>Edit Profile</h1>
        ) : (
          <>
            <h1> New Profile </h1>
            <p>
              {" "}
              Let's get a little bit of info about this new profile's owner
            </p>
          </>
        )}
        <div id="form_container">
          <ul>
            <form className="appnitro">
              <NameQuestion
                handleValue={handleValue}
                defaultName={props.defaultName}
              />
              <DoBQuestion
                handleValue={handleValue}
                defaultDOB={props.defaultDOB}
              />
              <GenderQuestion
                handleValue={handleValue}
                defaultGender={props.defaultGender}
                QDB={QDB}
              />
            </form>
          </ul>
          <div className="newProfileImageCont">
            <span className="newProfileImageItem">
              Select Profile Colors: <br />
              <ProfileImage color={getCol("f")} backgroundColor={getCol("B")} />
            </span>
            <span className="newProfileImageItem">
              Foreground
              <br />
              <ColorPicker
                handleChange={handleFG}
                colorArr={fgColorArr}
                defaultColor={props.defaultFG}
              />
            </span>
            <span className="newProfileImageItem">
              Background
              <br />
              <ColorPicker
                handleChange={handleBG}
                colorArr={bgColorArr}
                defaultColor={props.defaultBG}
              />
            </span>
          </div>
          <button
            onClick={handleSubmit}
            className="userActionButton submitButton"
          >
            Submit
          </button>
          <Popup open={open} onClose={closeModal}>
            <div className="header"> Missing Required Fields </div>
            <div className="modal_content">
              {check[0]}
              <br />
              {check[1]}
            </div>
            <div className="actions">
              <button
                className="userActionButton button"
                onClick={() => {
                  //console.log("modal closed ");
                  closeModal();
                }}
              >
                Okay
              </button>
            </div>
          </Popup>
          <Popup open={openConfirm} onClose={closeConfirmModal}>
            <div className="header">Are you Sure?</div>
            <div className="modal_content">
              Selecting "Okay" will change this profile and refresh this page.
            </div>
            <div className="actions">
              <button
                className="userActionButton button"
                onClick={() => {
                  ModifyProfile();
                }}
              >
                Okay
              </button>
              <button
                className="userActionButton button"
                onClick={() => {
                  //console.log("Confirmation modal closed ");
                  closeConfirmModal();
                }}
              >
                Cancel
              </button>
            </div>
          </Popup>
          <p></p>
        </div>
        <p />
      </div>
    </div>
  );
}

export default Home;
/*
        <ScorePercentDisplay
          curValue={305}
          maxValue={750}
          chartType="Offense"
        />*/
/*<div>
          <div style={{ width: 150, height: 150, display: "inline-block" }}>
            <CircularProgressbar
              value={600}
              maxValue={780}
              counterClockwise
              strokeWidth={16}
              text={`${600}`}
              styles={buildStyles({
                textColor: "#07115A",
                pathColor: "#07115A",
                strokeLinecap: "butt",
              })}
            />
          </div>
          <h3>{"Offense"}</h3>
          (out of {780})
        </div> */
